module.exports = __webpack_public_path__ + "static/NudistaLight-9af293dc68cf364b08341d7a5e8b56f9.ttf";